import ROUTES from "@consts/routes";
import i18n from "@/lang/i18n";

export default [
  {
    path: 'dashboard',
    name: ROUTES.CS.DASHBOARD,
    meta: {breadcrumb: i18n.tc('breadcrumbs.Home'), activeKey: 'cs.dashboard'},
    component: () => import("@components/cs/dashboard/Dashboard"),
  }
];
